import Vue from 'vue'
import { EagleListConfigInterface, TableDataType } from '@/components/list/types/list'
import dayjs from 'dayjs'
class listConfig {
  protected vm?: Vue
  protected listKey?: string

  get(vm: Vue, listKey: string) : EagleListConfigInterface {
    this.vm = vm
    this.listKey = listKey

    return {
      pageTitle: 'module.provider',
      search: 'provider.search_keyword2',
      filter: {
        status: {
          label: 'provider.data.status',
          type: 'selection',
          options: [
            'request',
            'apply',
            'reject',
          ],
          optionTextPrefix: 'provider.data.status',
        },
        created_at: {
          label: 'data.created_at',
          type: 'date',
        },
      },
      selectedData: row => ({
        id: row.id,
        name: row.name,
        title: row.title,
      }),
      displayMode: 'table',
      displayModeTypes: ['card', 'table'],
      sort: [
        { label: 'data.created_at', key: 'created_at' },
      ],
      card: {
        title: row => row.name,
        subtitle: row => row.name,
        avatarPhoto: row => row.avatar,
      },
      table: {
        data: <TableDataType>[
          {
            key: 'name',
            label: 'provider.data.name',
            type: 'text',
            isHtml: true,
            text: row => {
              const status = row.status
              if (status == 'apply') {
                return row.name
              }
              if (!row.created_at) {
                return `<span class="red--text">${row.name}</span>`
              }
              const isCreatedAtMoreThan14DaysAgo = dayjs().diff(dayjs(row.created_at), 'day') >= 14
              if (!isCreatedAtMoreThan14DaysAgo) {
                return row.name
              }
              return `<span class="red--text">${row.name}</span>`
            },
          },
          {
            key: 'status',
            label: 'provider.data.status',
            type: 'text',
            text: row => this.vm?.$t(`provider.data.status.${row.status}`),
          },
          {
            key: 'member_name',
            label: 'data.manager-name',
            type: 'text',
          },
          {
            key: 'created_at',
            label: 'data.created_at',
            type: 'time',
          },
        ],
      },
      batch: {
        delete: {
          targetLabel: row => row.name,
        },
      },
      metaAction: {},
      dataAction: {
        update: {
          label: 'action.edit',
          route: row => ({ name: 'provider-update', params: { target: row.id } }),
          linkTarget: '_self',
        },
        delete: {
          removeTarget: row => row.name,
        },
        loginViaOfficialMember: {
          label: '登入前台',
          // @ts-ignore
          callback: row => this.vm.loginViaOfficialMember(row),
        },
        bindAdmin: {
          component: () => import('modules/member/components/bindAdmin/bindAdminBtn.vue'),
        },
      },
    }

  }
}

export default new listConfig()
